const constants = {
    ROOT_URL :  "/ui/api"
}

export default constants